export default __webpack_public_path__ + "static/media/forms-check.c6d4a209.svg";